import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
export const PaymentConfirmationInfo = styled.div `
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  gap: ${spacing.large}px;
`;
